/**
 * 渲染公共快捷菜单
 */
import { namespace } from 'vuex-class';
import { Vue, Component, Watch } from 'vue-property-decorator';
const CommGetter = namespace('desk/comm').Getter;
const Action = namespace('desk/comm').Action;
@Component({})
export default class DataTypesMixin extends Vue {
  @Action private getAttributeData: any; // 获取全局基础类型列表
  @CommGetter private attributeData: any; // 公共类型
  private dataType = 0;
  private tableConfig: any = {columns: [{label: null}], data: []};
  private dataTypes: any = [{
    name: '时间',
    id: 0
  }];

  private get dataTypeDisabled() {
    return this.dataType !== 0;
  }

  private created() {
    this.setDataTypes();
    this.changeTableConfig();
  }

  @Watch('attributeData')
  private setDataTypes() {
    if (this.attributeData.data_type) {
      const typeData = this.attributeData.data_type.filter((item: any) => {
        if (item.id === this.dataType) {
          return item;
        }
      });
      this.dataTypes.unshift(...typeData);
    }
  }

  @Watch('dataType')
  private changeTableConfig() {
    const typeData = this.dataTypes.filter((item: any) => {
      if (item.id === this.dataType) {
        return item;
      }
    });
    if (typeData.length) {
      this.tableConfig.columns[0].label = typeData[0].name;
    }
  }
}
